export const LOADING = 'guests/LOADING';
export const GET_GUESTS = 'guests/GET_GUESTS';
export const ADD_GUEST_SUCCESS = 'guests/ADD_GUEST_SUCCESS';
export const UPLOAD_GUESTS_SUCCESS = "guests/UPLOAD_GUESTS_SUCCESS";